import React, { useState } from "react";
import { Header, Footer, Page } from "@/components/Shell";
import { API, SECTORS, SIZES } from "@/lib/brand";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";

export default function Identify() {
  const nav = useNavigate();
  const [form, setForm] = useState({ company_name: "", leader_name: "", email: "", phone: "", sector: "", company_size: "", website: "" });
  const [loading, setLoading] = useState(false);
  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.company_name || !form.email) { toast.error("Nom de l'entreprise et courriel sont requis."); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/clients`, form);
      localStorage.setItem("mb_token", data.token);
      nav(`/lecture/${data.token}`);
    } catch { toast.error("Une erreur est survenue. Veuillez réessayer."); }
    finally { setLoading(false); }
  };

  return (
    <Page tone="ivory">
      <Header variant="ivory" />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-20 pb-24" data-testid="identify-page">
        <div className="overline mb-6">Avant de commencer</div>
        <h1 className="font-display text-[44px] md:text-[52px] leading-tight text-ink">Faisons connaissance.</h1>
        <p className="mt-6 text-[19px] text-text-2 leading-relaxed max-w-xl">
          Ces informations servent à personnaliser votre rapport. Elles apparaîtront sur votre page couverture et permettront de produire une lecture plus professionnelle.
        </p>

        <form onSubmit={submit} className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
          <div className="md:col-span-2">
            <label className="overline block mb-3">Nom de l'entreprise</label>
            <input className="input-lux" value={form.company_name} onChange={on("company_name")} placeholder="ex. Atelier Lumière" data-testid="id-company" required />
          </div>
          <div>
            <label className="overline block mb-3">Nom du dirigeant</label>
            <input className="input-lux" value={form.leader_name} onChange={on("leader_name")} placeholder="ex. Camille Tremblay" data-testid="id-leader" />
          </div>
          <div>
            <label className="overline block mb-3">Courriel</label>
            <input type="email" className="input-lux" value={form.email} onChange={on("email")} placeholder="vous@entreprise.com" data-testid="id-email" required />
          </div>
          <div>
            <label className="overline block mb-3">Téléphone (facultatif)</label>
            <input className="input-lux" value={form.phone} onChange={on("phone")} placeholder="819 000-0000" data-testid="id-phone" />
          </div>
          <div>
            <label className="overline block mb-3">Site web (facultatif)</label>
            <input className="input-lux" value={form.website} onChange={on("website")} placeholder="https://" data-testid="id-website" />
          </div>
          <div>
            <label className="overline block mb-3">Secteur d'activité</label>
            <select className="input-lux" value={form.sector} onChange={on("sector")} data-testid="id-sector">
              <option value="">— Choisir —</option>
              {SECTORS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="overline block mb-3">Taille de l'entreprise</label>
            <select className="input-lux" value={form.company_size} onChange={on("company_size")} data-testid="id-size">
              <option value="">— Choisir —</option>
              {SIZES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div className="md:col-span-2 mt-6">
            <button type="submit" className="btn-primary" disabled={loading} data-testid="id-submit">
              {loading ? "Un instant…" : "Commencer ma lecture stratégique"}
            </button>
          </div>
        </form>
      </section>
      <Footer />
    </Page>
  );
}
